/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：356
 */

module.exports = {
  packageQrCodeDialog: "PackageQrCode_packageQrCodeDialog__2SzPS",
  packageInfo: "PackageQrCode_packageInfo__f2eSu",
  packageIcon: "PackageQrCode_packageIcon__2mdNT",
  packageTitle: "PackageQrCode_packageTitle__11Zz-",
  packageInfoItem: "PackageQrCode_packageInfoItem__3rJaS",
  packageAppId: "PackageQrCode_packageAppId__1wJdM",
  copyIcon: "PackageQrCode_copyIcon__3qNtL",
  qrCodeWrapper: "PackageQrCode_qrCodeWrapper__3lXM0",
  qrcode: "PackageQrCode_qrcode__HIYVK",
  mask: "PackageQrCode_mask__2E8Zd",
  apkText: "PackageQrCode_apkText__1qRW4",
  footerWrapper: "PackageQrCode_footerWrapper__1Klfy",
  footerBtn: "PackageQrCode_footerBtn__1zUNB",
  qrBtn: "PackageQrCode_qrBtn__DlhKh",
  iframeDownloader: "PackageQrCode_iframeDownloader__17lcv"
}
